const appUrlsDev = {
  logout: 'http://localhost:8090/server/logout.php',
  login: 'http://localhost:8090/server/login.php',
  events: 'http://localhost:8090/server/events.php',
  delete: 'http://localhost:8090/server/delete.php',
  save: 'http://localhost:8090/server/save.php'
};

const appUrlsProd = {
  logout: 'server/logout.php',
  login: 'server/login.php',
  events: 'server/events.php',
  delete: 'server/delete.php',
  save: 'server/save.php'
};

const mapKeysDev = {
  OSKARI_KEY: 'e4b64125-f3ad-49e2-b54e-bcb71f657472',
  OSKARI_ORIGIN: 'https://hkp.maanmittauslaitos.fi'
};

const mapKeysProd = {
  OSKARI_KEY: '3877e596-be98-4618-a9d1-1794319a6760', // Vanha tuotanto (https://turvallisuuskomitea.fi/harjoituskalenteri) -> '18c006ec-d7d0-41ac-84f2-ebfada523c7b'
  OSKARI_ORIGIN: 'https://hkp.maanmittauslaitos.fi'
};

// On production use appUrlsProd values!
const appUrls = appUrlsProd; // (process.env.NODE_ENV === 'production') ? appUrlsProd : appUrlsDev;
const mapKeys = mapKeysProd; // (process.env.SERVER === 'production') ? mapKeysProd : mapKeysDev;

const EPSG3067 = '+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs';
const EPSG4326 = '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs';

export { appUrls, mapKeys, EPSG3067, EPSG4326 };



// WEBPACK FOOTER //
// ./src/config.js